import { useMountEffect } from '@timelyapp/react';
import InputLabel from 'components/InputLabel';
import InputWithAutocomplete from 'components/InputWithAutocomplete';
import { SectionColumn, SectionRow } from 'components/ui-blocks/form/FormSection';
import { useWithDispatch } from 'hooks/useWithDispatch';
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  fetchAccountUserProperties,
  fetchAccountUserPropertiesPreviouslyUsedValues,
  fetchUserAccountProperties,
} from 'redux/modules/accounts.actions';
import { updateDraftUserProperty } from 'redux/modules/user.editor.types';
import {
  getAccountUserProperties,
  getUserPropertiesPreviouslyUsedValues,
} from 'redux/selectors/accounts';
import { getUserAccountPropertyDraftValues } from 'redux/selectors/user.editor';

const noOptions: Array<string> = [];

const UserAccountPropertiesSection: React.FC<{ userId: number | undefined }> = ({ userId }) => {
  const actions = useWithDispatch({
    fetchAccountUserProperties,
    fetchUserAccountProperties,
    fetchAccountUserPropertiesPreviouslyUsedValues,
    updateDraftUserProperty,
  });

  useMountEffect(() => {
    actions.fetchAccountUserProperties();
    actions.fetchAccountUserPropertiesPreviouslyUsedValues();
  });

  useEffect(() => {
    if (typeof userId === 'number') {
      actions.fetchUserAccountProperties(userId);
    }
  }, [actions, userId]);

  const accountProperties = useSelector(getAccountUserProperties);
  const userPropertiesPreviouslyUsedValues = useSelector(getUserPropertiesPreviouslyUsedValues);
  const userPropertyValues = useSelector(getUserAccountPropertyDraftValues);
  return accountProperties.map(field => (
    <SectionRow key={field.name}>
      <SectionColumn size="auto">
        <InputLabel>{field.name}</InputLabel>
        <InputWithAutocomplete
          options={userPropertiesPreviouslyUsedValues[field.id] || noOptions}
          size="medium"
          name={field.name}
          value={userPropertyValues[field.id] || ''}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            actions.updateDraftUserProperty({ id: field.id, value: e.target.value })
          }
        />
      </SectionColumn>
    </SectionRow>
  ));
};

export default memo(UserAccountPropertiesSection);
